export const FIRE_AGENCY_OPTION = 1065
export const LAW_AGENCY_OPTION = 1075
